// ==============================|| COMPANY TYPES ||============================== //

import { AddressDto } from './contacts';
import { FinancialCondition } from './financial-conditions';
import { Office } from './offices';
import { NamedEntityMinDto } from './other';

export interface CompanyMinDto {
    id: number;
    name: string;
    isActive?: boolean;
    isDefault?: boolean;
    customDateFormat?: string | null;
}

export interface Company {
    id: number;
    name: string;
    address: string;
    regCode?: string;
    vatRegCode: string;
    email?: string;
    phone?: string;
    isDefault?: boolean;
    isVatLiable?: boolean;
    isActive?: boolean;
    cityName: string;
    country_id: number;
    countryCode?: string;
    customDateFormat?: string | null;
    financialCondition?: FinancialCondition;
    bankAccounts?: CompanyIbanDto[];
    offices?: Office[];
}

export interface CorporateRoleFilling {
    corporateRoleFillingId: number;
    name: string;
    level: number;
    corporateRoleTypeCode: string;
    scopeTypeCode: string;
    roleFilledByEmployee?: NamedEntityMinDto;
    company?: NamedEntityMinDto;
    office?: NamedEntityMinDto;
}

export interface CorporateRoleFillingForm {
    corporateRoleFillings: UpdateCorporateRoleFillingDto[];
}

export interface UpdateCorporateRoleFillingDto {
    corporateRoleFillingId: number;
    roleFilledByEmployee: NamedEntityMinDto | null;
}

export enum CorporateRoleType {
    LEADING_REVENUE_PERSON = 'LEADING_REVENUE_PERSON',
    LEADING_COMPLIANCE_PERSON = 'LEADING_COMPLIANCE_PERSON',
}

export interface CompanyIbanDto {
    id: number | null;
    iban: string | null;
    currencyTypeCode: string | null;
    ibanReceiverName: string | null;
    bankName: string | null;
    bankCode: string | null;
    bankSwift: string | null;
    bankAddress: AddressDto | null;
    mainIban?: boolean;
}

export interface CompanyBankAccountsGroupedDto {
    companyId: number;
    companyName: string;
    bankAccounts: CompanyBankAccountMinDto[];
}

interface CompanyBankAccountMinDto {
    id: number;
    iban: string;
    mainIban?: boolean;
}
